<template lang="pug">
div(class='bg-gray-lighter pb-10 lg:pb-0')
  div(class='lg:border lg:mt-5 lg:bg-white')
    div(class='text-center text-lg font-bold color-dark py-3 uppercase whitespace-nowrap lg:bg-gray-lightest')
      | Need Help?
      span(class='block ml-1 lg:inline-block') Give us a call #[UniversalLink(link='PHONE' class='text-gray-darkest hover:underline') {{ $sitewideConfig.config.phoneGeneral }}]
</template>

<script lang="ts" setup>
const { $sitewideConfig, $invoca } = useNuxtApp()
const { isIntegrationEnabled } = useUtils()

onMounted(() => {
  if (isIntegrationEnabled('invoca')) $invoca.changePhone()
})
</script>
